import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import SaveIcon from '@mui/icons-material/Save';

/**
 * Reusable navigation buttons row for wizard steps.
 *
 * Props:
 *  - onBack: () => void
 *  - onNext: () => void
 *  - loading: boolean  (disables next and shows spinner)
 *  - nextLabel: string (default 'Siguiente')
 *  - backLabel: string (default 'Atrás')
 *  - isSave: boolean   (uses SaveIcon instead of ArrowForwardIcon, default false)
 *  - nextDisabled: boolean (additional disabled condition for next button)
 */
export default function StepNavButtons({
  onBack,
  onNext,
  loading = false,
  nextLabel = 'Siguiente',
  backLabel = 'Atrás',
  isSave = false,
  nextDisabled = false,
}) {
  const NextIcon = loading
    ? <CircularProgress size={20} color="inherit" />
    : isSave
      ? <SaveIcon />
      : <ArrowForwardIcon />;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
      <Button
        variant="outlined"
        startIcon={<ArrowBackIcon />}
        onClick={onBack}
        disabled={loading}
        sx={{
          color: '#94a3b8',
          borderColor: 'rgba(255, 255, 255, 0.2)',
          borderRadius: 0,
          '&:hover': { borderColor: '#cbd5e1', background: 'rgba(255, 255, 255, 0.05)' },
        }}
      >
        {backLabel}
      </Button>
      <Button
        variant="contained"
        endIcon={NextIcon}
        onClick={onNext}
        disabled={loading || nextDisabled}
        sx={{
          background: '#3a6eb6',
          borderRadius: 0,
          '&:hover': { background: '#2a5793' },
          '&:disabled': { background: 'rgba(58, 110, 182, 0.3)' },
        }}
      >
        {nextLabel}
      </Button>
    </Box>
  );
}
